var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictureSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8201 14.8224L14.8224 14.8201C15.4739 14.1672 16.2683 13.833 17.3126 13.833H56.6868C57.731 13.833 58.5254 14.1672 59.177 14.8201L59.1792 14.8224C59.8322 15.4739 60.1663 16.2683 60.1663 17.3126V56.6868C60.1663 57.7321 59.8325 58.5268 59.1812 59.1781C58.5272 59.8321 57.7311 60.1663 56.6868 60.1663H17.3126C16.2673 60.1663 15.4726 59.8325 14.8212 59.1812C14.1672 58.5272 13.833 57.7311 13.833 56.6868V17.3126C13.833 16.2683 14.1672 15.4739 14.8201 14.8224ZM21.9312 49.966L20.0974 52.3747H23.1247H51.3495H54.3492L52.5496 49.9748L43.833 38.3506L42.6643 36.792L41.4562 38.3203L34.5434 47.065L30.3299 41.9727L29.1253 40.5169L27.9807 42.0203L21.9312 49.966Z",
    stroke: "white",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureSymbol);
export default __webpack_public_path__ + "static/media/pictureSymbol.f34df1b2fc9856b33c1114affa5637bf.svg";
export { ForwardRef as ReactComponent };